
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ts-reset",
      function () {
        return require("private-next-pages/ts-reset/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ts-reset"])
      });
    }
  